import Crafting from '../../../../wttrpg/Crafting';

export default {
    BERSERKERS_AXE: {
        name: 'Berserker\'s Axe',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.MAHAKAMAN_STEEL.item, amount: 4 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 5 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.STEEL.item, amount: 2 },
            { component: Crafting.RESIN.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 1 },
        ],
        investment: 722,
        cost: 1440,
    },
    CRYSTAL_STAFF: {
        name: 'Crystal Staff',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.TIMBER.item, amount: 6 },
            { component: Crafting.STEEL.item, amount: 2 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 4 },
            { component: Crafting.ESTER_GREASE.item, amount: 3 },
            { component: Crafting.WAX.item, amount: 1 },
            { component: Crafting.GEMSTONE.item, amount: 1 },
            { component: Crafting.ETCHING_ACID.item, amount: 4 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
        ],
        investment: 623,
        cost: 1296,
    },
    HIGHLAND_MAULER: {
        name: 'Highland Mauler',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.DARK_IRON.item, amount: 5 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 7 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.ETCHING_ACID.item, amount: 4 },
            { component: Crafting.BEAST_BONES.item, amount: 10 },
            { component: Crafting.ESTER_GREASE.item, amount: 4 },
            { component: Crafting.METEORITE.item, amount: 1 },
        ],
        investment: 720,
        cost: 1440,
    },
    IRON_STAFF: {
        name: 'Iron Staff',
        DC: 20,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.DARK_IRON.item, amount: 4 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.LEATHER.item, amount: 1 },
            { component: Crafting.ETCHING_ACID.item, amount: 2 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
        ],
        investment: 506,
        cost: 1012,
    },
    JAMBIYA: {
        name: 'Jambiya',
        DC: 20,
        craftTime: '5 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
            { component: Crafting.DRACONID_LEATHER.item, amount: 1 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.STEEL.item, amount: 2 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 2 },
            { component: Crafting.RESIN.item, amount: 1 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
        ],
        investment: 342,
        cost: 660,
    },
    KORD: {
        name: 'Kord',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 3 },
            { component: Crafting.DARK_IRON.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.RESIN.item, amount: 4 },
            { component: Crafting.BEAST_BONES.item, amount: 7 },
            { component: Crafting.SILK.item, amount: 1 },
        ],
        investment: 525,
        cost: 1012,
    },
    MONSTER_HUNTERS_CROSSBOW: {
        name: 'Monster Hunter\'s Crossbow',
        DC: 24,
        craftTime: '12 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.THREAD.item, amount: 6 },
            { component: Crafting.WAX.item, amount: 4 },
            { component: Crafting.RESIN.item, amount: 4 },
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
            { component: Crafting.OGRE_WAX.item, amount: 4 },
            { component: Crafting.DARK_IRON.item, amount: 2 },
            { component: Crafting.BEAST_BONES.item, amount: 4 },
        ],
        investment: 844,
        cost: 1686,
    },
    RED_HALBERD: {
        name: 'Red Halberd',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.DARK_STEEL.item, amount: 3 },
            { component: Crafting.TRETEGOR_STEEL.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
        ],
        investment: 647,
        cost: 1296,
    },
    TORRWR: {
        name: 'Torrwr',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 3 },
            { component: Crafting.DARK_STEEL.item, amount: 5 },
            { component: Crafting.STEEL.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.RESIN.item, amount: 5 },
            { component: Crafting.ASHES.item, amount: 4 },
            { component: Crafting.BEAST_BONES.item, amount: 2 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
        ],
        investment: 760,
        cost: 1462,
    },
    VICOVARIAN_BLADE: {
        name: 'Vicovarian Blade',
        DC: 24,
        craftTime: '12 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 3 },
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.DARK_IRON.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.RESIN.item, amount: 4 },
            { component: Crafting.ASHES.item, amount: 4 },
            { component: Crafting.BEAST_BONES.item, amount: 5 },
        ],
        investment: 660,
        cost: 1282,
    },
    WAR_BOW: {
        name: 'War Bow',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.THREAD.item, amount: 6 },
            { component: Crafting.WAX.item, amount: 4 },
            { component: Crafting.RESIN.item, amount: 4 },
            { component: Crafting.ESTER_GREASE.item, amount: 3 },
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.DRAKE_OIL.item, amount: 2 },
        ],
        investment: 626,
        cost: 1296,
    },
}


// {
//     name: '',
//     DC: 25,
//     craftTime: '13 Hours',
//     ingredients: [
//         { component: Crafting..item, amount: 1 },
//         { component: Crafting..item, amount: 2 },
//     ],
//     investment: ,
//     cost: ,
// },